import { Redirect, Route, Switch, Router } from 'react-router-dom';
import { history } from '../store';
import Investors from '../components/investors';
import OnboardingRouter from '../components/onboarding/Router';
import MobileLogin from '../components/auth/MobileLogin';
import LoginOtp from '../components/auth/loginOtp';
import RedirectRoute from './RedirectRoute';
import ProtectedRoute from './ProtectedRoute';
import ApplicationRoutes from '../components/investors/routes';
import Profile from '../components/profile/index';
import ApplicationDetails from '../components/ApplicationDetails/index';
import { useEffect } from 'react';
import { useSnackbar, VariantType } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';
import InvestorRoutes, { EditApplication } from '../components/Investments/routes';
import UserManagementLayOut from '../components/userManagement/router';
import { USER_ROLES } from '../utils/constant';
import { FundsSetup } from '../components/FundsSetup';
import { RiskProfile } from '../components/RiskProfile';
import { AMCAdminsList } from '../components/AmcAdmins';
import ApplicationEsignList from '../components/ApplicationsEsignList';
import { CLEAR_GLOBAL_ERROR } from '../redux-store/types/auth';
import { useModal } from 'mui-modal-provider';
import SimpleDialog, { CommonLayout } from '../components/commonComponents';
import NonIndividualApplicationRoutes, {
  NonIndividualApplicationEdit,
} from '../components/NonIndividualInvestor/routes';
import Reports from '../components/Reports/reports';
import { NonIndividualApplicationDetail } from '../components/NonIndividualApplicationDetails';
import ConsentEmailApproveReject, {
  ConsentEmailApplicationsList,
  ConsentEmailApprove,
  ConsentEmailReject,
} from '../components/ConsentEmailComponent';
import adminSupport from '../components/adminSupport';
import LoginRequireRoute from './LoginRequireRoute';
import Dashboard from '../components/dashboard';
import InvestorDashboard from '../components/dashboard/investor-dashboard';
import InvestorDetails from '../components/dashboard/investor-details';
import TotalRmDetail from '../components/dashboard/total-rm-detail';
import BookSizeDetail from '../components/dashboard/book-size-details';
import NetSales from '../components/dashboard/net-sales';
import TotalRevenue from '../components/dashboard/total-revenue';
import GrossSales from '../components/dashboard/gross-sales';
import IndividualInvestor from '../components/dashboard/individual-investor';
import ProductDetails from '../components/dashboard/product-details';
import DirectEquity from '../components/dashboard/direct-equity/direct-equity';
import { getRmDetails } from '../redux-store/actions/userManagement';
import PMS from '../components/dashboard/pms/pms';
import InvestorReportRoute from '../components/InvestorReport/routesReport';
import AIF from '../components/dashboard/aif';
import Bonds from '../components/dashboard/bonds/index';
import InvestorTransactions from '../components/dashboard/investor-transaction/investor-transactions';
import DashboardReportRoute from '../components/dashboard/Reports_Dashboard/routes';
import { formatDate } from '../utils/utilityFunctions';
import RecommendedSchemes from '../components/dashboard/investor-transaction/recommended-schemes'
import Holding from '../components/dashboard/investor-transaction/holdings'
import STP_SWP from '../components/dashboard/investor-transaction/STP-SWP'
import SwitchComp from '../components/dashboard/investor-transaction/Switch'
import Redeem from '../components/dashboard/investor-transaction/Redeem'
import SIPLumpsum from '../components/dashboard/investor-transaction/SIP-Lumpsum'
import SIP from '../components/dashboard/investor-transaction/SIP-Lumpsum'
import InvestorProfileRouter from "../components/investorOverview/InvestorProfileRouter";
import IndividualFundDetails from '../components/investorOverview/fundDetails';
import InvestorLoginRouter from '../components/investorOverview/InvestorLoginRouter';
import InvestorRecommendations from '../components/investorOverview/InvestorRecommendations';
import { storeInvestorClientId, storeIwappId } from '../redux-store/actions/id';
import { getCartItemsCount, setCartItemsCount } from '../redux-store/actions/cart';
import { GetCartItemsCountResponseBody } from '../redux-store/types/cart';
import CategoryWiseActionItems from '../components/investorOverview/mutualFund/CategoryWiseActionItems';
import SidebarMFCategoryWiseBreakup from '../components/dashboard/SidebarMFCategoryWiseBreakup';
import ProductsRouter from '../components/products/productsRouter';
import FamiliesRouter from '../components/family/familiesRouter';
import JointHolderType from '../components/auth/JointHolderType';
import { getInvestorDetails } from '../redux-store/actions/investorProfile';
import { getBusinessDate, setNavbarInfo, setNavbarInfoLoading } from '../redux-store/actions/navbarInfo';
import { GetBusinessDateResponseBody } from '../redux-store/types/navbarInfo';
// import Analytics from '../components/analytics';
import FamilyProfileDetails from '../components/family/FamilyProfileDetails';
import AnalyticsRouter from '../components/analytics/analyticsRouter';
import OnBoardingDashBoard from '../components/OnBoardingDashboard/index'
import { getCurrencyInfo, setCurrencyInfo } from '../redux-store/actions/currencyInfo';
import { GetCurrencyInfoResponseBody } from '../redux-store/types/currencyInfo';
import OrderManagementRouter from '../components/orderManagement/orderManagementRouter';
import OrdersApproval from '../components/ordersApproval';
import OrderDetails from '../components/ordersApproval/orderDetails';
import PaymentsApproval from '../components/paymentsApproval';
import PaymentDetails from '../components/paymentsApproval/paymentDetails';
import InvOnboardingRoutes from '../components/InvestorOnboarding/InvOnboardingRoutes';
import InvApplicationRoutes from '../components/InvestorOnboarding/InvApplicationRoutes';
import CartRouter from '../components/Cart/CartRouter';
import PaymentRouter from '../payment/paymentRouter';
import BseTradeSuccess from '../components/investorOverview/BseTradeSuccess';
import BanksRouter from '../components/banks/banksRouter';
import NomineeRouter from '../components/nominee/nomineeRouter';
import SelectRole from '../components/auth/SelectRole';
import RouteAnnouncer from '../components/RouteAnnouncer';

// import Orders from '../components/dashboard/investor-transaction/orders'

function AppRoutes(): JSX.Element {
  const dispatch = useDispatch();
  const { toaster, message, severity } = useSelector((state: RootStateType) => state.toast);
  const { id: userId, role = '', token = '', diyInvestorOnboarding = false, diyInvestorOnboardingEdit = false, diyInvOnboardingPrev = false, subRole = "" } = useSelector((state: RootStateType) => state.auth);
  const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
  const { enqueueSnackbar } = useSnackbar();
  const { showModal, state: modalState } = useModal();
  const errorState = useSelector((store: RootStateType) => store.error);
  const { investorClientId = '', clientInterfaceCode, applicationId = '' } = useSelector((store: RootStateType) => store.id);
  useEffect(() => {
    toaster && enqueueSnackbar(message, { variant: severity as VariantType });
  }, [toaster]);

  useEffect(() => {
    if (errorState && Object.keys(modalState ?? {}).length === 0) {
      const { error = '' } = errorState;
      const { destroy } = showModal(SimpleDialog, {
        content: error,
        actions: [
          {
            label: 'OK',
            onClick: () => {
              destroy();
              dispatch({ type: CLEAR_GLOBAL_ERROR });
            },
          },
        ],
      });
    }
  }, [errorState]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const urlContent = window.location.pathname.split("/")
        if (urlContent[1] === 'payment-flow') return;
        if (userId && (role === USER_ROLES.RM || role === USER_ROLES.OPE)) {
          dispatch(setNavbarInfoLoading(true));

          const [getCurrencyInfoResponse, getRmDetailsResponse, getBusinnessDateResponse] = await Promise.allSettled([
            dispatch(getCurrencyInfo() as unknown as Promise<GetCurrencyInfoResponseBody>),
            dispatch(getRmDetails()),
            dispatch(getBusinessDate() as unknown as Promise<GetBusinessDateResponseBody>)
          ])

          // const res: any = await dispatch(getRmDetails());

          if (getCurrencyInfoResponse?.status === "fulfilled" && getCurrencyInfoResponse?.value?.isSuccess) {
            const currencyInfoDetails = getCurrencyInfoResponse?.value?.result as any;

            dispatch(setCurrencyInfo({
              locale: currencyInfoDetails?.locale ?? "en-IN",
              currencyCode: currencyInfoDetails?.currencyCode ?? "INR",
              currencySymbol: currencyInfoDetails?.currencySymbol ?? "20B9"
            }));
          }

          if (getRmDetailsResponse?.status === "fulfilled") {
            const rmDetails = getRmDetailsResponse?.value as any;

            dispatch(storeIwappId({ iwappRmId: rmDetails?.iwappRmId }));
          }

          // const { isSuccess: isGetBusinessDateSuccess, result: getBusinessDateResult } = await (dispatch(getBusinessDate() as unknown as Promise<GetBusinessDateResponseBody>))

          if (getRmDetailsResponse?.status === "fulfilled" && (getBusinnessDateResponse?.status === "fulfilled" && getBusinnessDateResponse?.value?.isSuccess)) {
            const rmDetails = getRmDetailsResponse?.value as any;
            const businessDateResult = getBusinnessDateResponse?.value?.result as any;
            const environment = getBusinnessDateResponse?.value?.environment;

            const company = businessDateResult?.companyName?.split(" ");
            const companyName = (company?.[0] ?? "") + (" ") + (company?.[1] ?? "");

            dispatch(setNavbarInfo(rmDetails?.name ?? "", businessDateResult?.businessDate ?? "", companyName ?? "",
              environment ?? "", rmDetails?.userRole ?? ""));
          }
        }

        if (userId && role === USER_ROLES.INVESTOR) {
          dispatch(setNavbarInfoLoading(true));

          const urlContent = window.location.pathname.split("/")

          const getCurrencyInfoResponse = await dispatch(getCurrencyInfo() as unknown as Promise<GetCurrencyInfoResponseBody>)

          if (getCurrencyInfoResponse?.isSuccess) {
            const currencyInfoDetails = getCurrencyInfoResponse?.result

            dispatch(setCurrencyInfo({
              locale: currencyInfoDetails?.locale ?? "en-IN",
              currencyCode: currencyInfoDetails?.currencyCode ?? "INR",
              currencySymbol: currencyInfoDetails?.currencySymbol ?? "20B9"
            }));
          }

          if (!(urlContent[1] === "investment-details" && urlContent[3] === "application-details" && urlContent.length === 4)) {

            if (selectedPortfolio?.value) {

              const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                portfolioId: selectedPortfolio?.value
              })) as unknown as Promise<GetCartItemsCountResponseBody>)

              if (isSuccess) {
                dispatch(setCartItemsCount(cartItemsCount));
              }
            }
            const { isSuccess: isGetBusinessDateSuccess, result: getBusinessDateResult, environment } = await (dispatch(getBusinessDate() as unknown as Promise<GetBusinessDateResponseBody>))
            if (isGetBusinessDateSuccess) {

              const company = getBusinessDateResult?.companyName?.split(" ");
              const companyName = (company?.[0] ?? "") + (" ") + (company?.[1] ?? "");
              dispatch(setNavbarInfo("", getBusinessDateResult?.businessDate ?? "", companyName ?? "", environment ?? "", ""));
            }
          }
        }
        if (userId && role === USER_ROLES.AMCAPPROVER) {
          const getCurrencyInfoResponse = await dispatch(getCurrencyInfo() as unknown as Promise<GetCurrencyInfoResponseBody>)

          if (getCurrencyInfoResponse?.isSuccess) {
            const currencyInfoDetails = getCurrencyInfoResponse?.result

            dispatch(setCurrencyInfo({
              locale: currencyInfoDetails?.locale ?? "en-IN",
              currencyCode: currencyInfoDetails?.currencyCode ?? "INR",
              currencySymbol: currencyInfoDetails?.currencySymbol ?? "20B9"
            }));
          }
        }
      } catch (error) {
        console.log("Error: ", error)
      } finally {
        dispatch(setNavbarInfoLoading(false));
      }
    }

    fetch()
  }, [userId]);

  const ScrollToTopOnPageChange = () => {

    useEffect(() => {
      const unlisten = history.listen(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page on route change
      });
      return () => {
        unlisten();
      };
    }, [history]);

    return null;
  };

  const getBaseRoute = () => {
    if ([USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role)) {
      // return '/applications';
      return '/dashboard';
    }
    else if ([USER_ROLES.AMCAPPROVER].includes(role) && [USER_ROLES.POACHECKER].includes(subRole)) {
      return '/payments-approval';
    }
    else if (
      [
        USER_ROLES.TRUSTEE,
        USER_ROLES.FUND_MANAGER,
        USER_ROLES.POAAPPROVER,
        USER_ROLES.AMCAPPROVER,
      ].includes(role)
    ) {
      return '/applications-list';
    } else if ([USER_ROLES.AMC_ADMIN].includes(role)) {
      // return '/dashboard';
      return '/user-management';
    } else if ([USER_ROLES.INVESTOR].includes(role)) {
      // return '/dashboard';
      if (diyInvOnboardingPrev && applicationId) {
        return `/investor-onboarding-application-details/${applicationId}`;
      }
      if (diyInvestorOnboarding || diyInvestorOnboardingEdit) {
        return '/investor-onboarding-application/rm-details'
      }
      return '/investor-dashboard';
    } else {
      return '/applications';
    }
  };

  return (
    <Router history={history}>
      {ScrollToTopOnPageChange()}
      <RouteAnnouncer />
      <Switch>
        <Route
          exact
          path="/"
          render={(props: any) => (
            <Redirect {...props} to={getBaseRoute()} from={props.location.pathname} />
          )}
        />
        <RedirectRoute path="/login" component={MobileLogin} title="Login" />
        <RedirectRoute path="/verify-otp" component={LoginOtp} title="Verify OTP" />
        <RedirectRoute path="/joint-holder" component={JointHolderType} title="Joint Holder" />
        <RedirectRoute path="/select-role" component={SelectRole} title="Select Role" />
        <RedirectRoute path="/investor-onboarding" component={InvOnboardingRoutes} title="Investor Onboarding" />
        <ProtectedRoute
          path="/bsetrade"
          component={BseTradeSuccess}
          acceptedRoles={[USER_ROLES.INVESTOR]}
          title="Trade Success"
        />
        <ProtectedRoute path="/investor-onboarding-application" component={InvApplicationRoutes} acceptedRoles={[USER_ROLES.INVESTOR]} title="Onboarding Application" />
        <ProtectedRoute path="/add-diy-joint-holder" component={InvOnboardingRoutes} acceptedRoles={[USER_ROLES.INVESTOR]} title="Add Joint Holder" />
        <ProtectedRoute path="/dashboard" component={Dashboard} acceptedRoles={[USER_ROLES.RM , USER_ROLES.OPE]} title="Dashboard" />
        {/* <ProtectedRoute path="/analytics" component={Analytics} acceptedRoles={[USER_ROLES.RM,, USER_ROLES.OPE]} /> */}
        <ProtectedRoute path='/fundDetails' component={IndividualFundDetails} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="Fund Details" />
        <Route path="/product">
          <Switch>
            <Route exact path="/product" render={() => <Redirect to="/product/mutual-fund" />} />
            <ProtectedRoute
              path="/product"
              component={ProductsRouter}
              acceptedRoles={[USER_ROLES.RM,USER_ROLES.OPE, USER_ROLES.INVESTOR]}
              title="Products"
            />
          </Switch>
        </Route>
        <Route path="/family">
          <Switch>
            <Route exact path="/family" render={() => <Redirect to="/family/ViewFamily" />} />
            <ProtectedRoute
              path="/family"
              component={FamiliesRouter}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.INVESTOR]}
              title="Families"
            />
          </Switch>
        </Route>
        <Route path="/investor-family">
          <Switch>
            <Route exact path="/investor-family" render={() => <Redirect to="/investor-family/invFamRouteCheck" />} />
            <ProtectedRoute
              path="/investor-family"
              component={FamiliesRouter}
              acceptedRoles={[USER_ROLES.INVESTOR]}
              title="Family"
            />
          </Switch>
        </Route>
        <Route path="/bank">
          <Switch>
            <Route exact path="/bank" render={() => <Redirect to="/bank/updateBank" />} />
            <ProtectedRoute
              path="/bank"
              component={BanksRouter}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.INVESTOR]}
              title="Banks"
            />
          </Switch>
        </Route>
        <Route path="/nominee">
          <Switch>
            <Route exact path="/nominee" render={() => <Redirect to="/nominee/updateNominee" />} />
            <ProtectedRoute
              path="/nominee"
              component={NomineeRouter}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.INVESTOR]}
              title="Nominee"
            />
          </Switch>
        </Route>
        <Route path="/analytics">
          <Switch>
            <Route exact path="/analytics" render={() => <Redirect to="/analytics/portfolio-analytics" />} />
            <ProtectedRoute
              path="/analytics"
              component={AnalyticsRouter}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.INVESTOR]}
              title="Analytics"
            />
          </Switch>
        </Route>
        <Route path="/orders">
          <Switch>
            <Route exact path="/orders" render={() => <Redirect to="/orders/order-dashboard" />} />
            <ProtectedRoute
              path="/orders"
              component={OrderManagementRouter}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
              title="Orders"
            />
          </Switch>
        </Route>
        <ProtectedRoute
          path="/investors"
          component={InvestorDashboard}
          acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
          title="Investors"
        />
        <ProtectedRoute
          path="/onboard-overview"
          component={OnBoardingDashBoard}
          acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
          title="Onboarding Overview"
        />
        {/* <ProtectedRoute path="/joint-holder" component={JointHolderType} acceptedRoles={[USER_ROLES.INVESTOR]} /> */}
        <ProtectedRoute
          path="/investor-dashboard"
          component={InvestorLoginRouter}
          acceptedRoles={[USER_ROLES.INVESTOR]}
          title="Investor Dashboard"
        />
        <ProtectedRoute
          path="/investor-recommendations"
          component={InvestorRecommendations}
          acceptedRoles={[USER_ROLES.INVESTOR]}
          title="Recommendations"
        />
        <ProtectedRoute
          path="/cart"
          component={CartRouter}
          acceptedRoles={[USER_ROLES.INVESTOR]}
          title="Cart"
        />
        <ProtectedRoute
          path="/investor-details"
          component={InvestorDetails}
          acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
          title="Investor Details"
        />
        <ProtectedRoute
          path="/total-rm-detail"
          component={TotalRmDetail}
          acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
          title="Total RMs"
        />
        <ProtectedRoute
          path="/book-size-detail"
          component={BookSizeDetail}
          acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
          title="Book Size"
        />
        <ProtectedRoute path="/net-sales" component={NetSales} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="Net Sales" />
        <ProtectedRoute path="/total-revenue" component={TotalRevenue} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="Total Revenue" />
        <ProtectedRoute path="/investor-transactions" component={InvestorTransactions} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="Investor Transactions" />
        <ProtectedRoute path="/recommended-schemes" component={RecommendedSchemes} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="Recommended Schemes" />
        <ProtectedRoute path="/holdings" component={Holding} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="Holdings" />
        {/* <ProtectedRoute path="/orders" component={Orders} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} /> */}
        <ProtectedRoute path="/SIP_Lumpsum" component={SIPLumpsum} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="SIP & Lumpsum" />
        <ProtectedRoute path="/STP_SWP" component={STP_SWP} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="STP & SWP" />
        <ProtectedRoute path="/Switch" component={SwitchComp} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="Switch" />
        <ProtectedRoute path="/Redeem" component={Redeem} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="Redeem" />

        <ProtectedRoute
          path="/gross-sales"
          component={GrossSales}
          acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
          title="Gross Sales"
        />
        <ProtectedRoute
          path="/applications"
          component={Investors}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
          title="Applications"
        />
        <ProtectedRoute
          path="/onboarding"
          component={OnboardingRouter}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Onboarding"
        />
        <ProtectedRoute
          path="/investor-profile/:investorId"
          component={InvestorProfileRouter}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Investor Profile"
        />
        {/* <ProtectedRoute
          path="/family-profile/:familyId"
          component={FamilyProfileDetails}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
        /> */}
        <ProtectedRoute
          path="/application"
          component={ApplicationRoutes}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
          title="Application"
        />
        <ProtectedRoute
          path="/non-individual-application"
          component={NonIndividualApplicationRoutes}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
          title="Non Individual Application"
        />
        <ProtectedRoute
          path="/profile"
          component={Profile}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
          title="Profile"
        />
        <ProtectedRoute
          path="/application-details/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.POAAPPROVER,
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Application Details"
        />
        <ProtectedRoute
          path="/application-checker-details/edit-application"
          component={EditApplication}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Edit Application"
        />
        <ProtectedRoute
          path="/investor-onboarding-application-details/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.INVESTOR
          ]}
          title="Application Details"
        />
        <ProtectedRoute
          path="/funds-setup"
          component={FundsSetup}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
          title="Funds Setup"
        />
        <ProtectedRoute
          path="/risk-profile"
          component={RiskProfile}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
          title="Risk Profile"
        />
        <ProtectedRoute
          path="/amc-admins"
          component={AMCAdminsList}
          acceptedRoles={[USER_ROLES.SUPER_ADMIN, USER_ROLES.DISTRIBUTOR]}
          title="AMC Admins"
        />
        <ProtectedRoute
          path="/reports"
          component={Reports}
          acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.AMC_ADMIN, USER_ROLES.AMCAPPROVER]}
          title="Reports"
        />
        <ProtectedRoute
          path="/applications-list"
          component={ApplicationEsignList}
          acceptedRoles={[
            USER_ROLES.TRUSTEE,
            USER_ROLES.FUND_MANAGER,
            USER_ROLES.POAAPPROVER,
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Applications List"
        />
        <ProtectedRoute
          path="/orders-approval"
          component={OrdersApproval}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Orders Approval"
        />
        <ProtectedRoute
          path="/order-details"
          component={OrderDetails}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Order Details"
        />
        <ProtectedRoute
          path="/payments-approval"
          component={PaymentsApproval}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Payments Approval"
        />
        <ProtectedRoute
          path="/payment-details"
          component={PaymentDetails}
          acceptedRoles={[
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Payment Details"
        />
        <ProtectedRoute
          path="/user-management"
          component={UserManagementLayOut}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
          title="User Management"
        />
        <ProtectedRoute
          path="/non-individual-application-details/:id"
          component={NonIndividualApplicationDetail}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Application Details"
        />
        <ProtectedRoute
          path="/non-individual-application-edit"
          component={NonIndividualApplicationEdit}
          acceptedRoles={[USER_ROLES.AMCAPPROVER]}
          title="Edit Application"
        />
        <ProtectedRoute
          path="/application-preview/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
          title="Application Preview"
        />
        <ProtectedRoute
          path="/investor-onboarding-application-preview/:id"
          component={ApplicationDetails}
          acceptedRoles={[
            USER_ROLES.INVESTOR,
          ]}
          title="Application Preview"
        />
        <ProtectedRoute
          path="/non-individual-application-preview/:id"
          component={NonIndividualApplicationDetail}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
          ]}
          title="Application Preview"
        />
        <Route path='/payment-flow' component={PaymentRouter} />
        <Route path="/investment-details" component={InvestorRoutes} />
        <Route path="/investor-consent/:verificationToken" component={ConsentEmailApproveReject} />
        <Route path="/investor-consent-approved" component={ConsentEmailApprove} />
        <Route path="/investor-consent-reject" component={ConsentEmailReject} />
        <ProtectedRoute
          path="/view-consent-email-list"
          component={ConsentEmailApplicationsList}
          acceptedRoles={[
            USER_ROLES.AMC_ADMIN,
            USER_ROLES.RM,
            USER_ROLES.OPE,
            USER_ROLES.DISTRIBUTOR,
            USER_ROLES.SUBDISTRIBUTOR,
            USER_ROLES.AMCAPPROVER,
          ]}
          title="Consent Email List"
        />
        <ProtectedRoute
          path="/admin-support"
          component={adminSupport}
          acceptedRoles={[USER_ROLES.AMC_ADMIN]}
          title="Admin Support"
        />
        <Route path="/">
          <Switch>
            <ProtectedRoute
              exact
              path="/investor"
              component={IndividualInvestor}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
              title="Investor"
            />
            {/* <ProtectedRoute
              path="/investor-reports"
              component={InvestorReportRoute}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
            /> */}
            <ProtectedRoute
              path="/investor-reports"
              component={InvestorReportRoute}
              acceptedRoles={[USER_ROLES.INVESTOR]}
              title="Investor Reports"
            />
            <ProtectedRoute
              path="/reports-download"
              component={DashboardReportRoute}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE, USER_ROLES.AMC_ADMIN]}
              title="Reports Download"
            />
            <ProtectedRoute
              path="/investor/mutual-fund"
              component={ProductDetails}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
              title="Mutual Funds"
            />
            <ProtectedRoute
              path="/investor/direct-equity"
              component={DirectEquity}
              acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]}
              title="Direct Equity"
            />
            <ProtectedRoute path="/investor/pms" component={PMS} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="PMS" />
            <ProtectedRoute path="/investor/aif" component={AIF} acceptedRoles={[USER_ROLES.RM, USER_ROLES.OPE]} title="AIF" />
          </Switch>
        </Route>
        <LoginRequireRoute path="*" />
      </Switch>
    </Router>
  );
}

export default AppRoutes;
